import { securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export const forgotPassLogging = async (request, response, section) => {
  return securePost("/api/survey/ForgotPasswordLogging", { request, response, section });
};

export const forgotUser = async (emailId) => {
  const requestObject = { emailId };
  try {
    const response = await securePost("/api/survey/loopSurveyForgotPassword", requestObject);
    await forgotPassLogging(
      JSON.stringify(requestObject),
      JSON.stringify(response),
      "forgot_password_initiated"
    );
    return response;
  } catch (error) {
    await forgotPassLogging(
      JSON.stringify(requestObject),
      JSON.stringify(error),
      "forgot_password_initiated_error"
    );
    throw error;
  }
};